import { render } from "./main.vue?vue&type=template&id=53f99160&scoped=true&ts=true"
import script from "./main.vue?vue&type=script&lang=ts"
export * from "./main.vue?vue&type=script&lang=ts"

import "../style/index.scss?vue&type=style&index=0&id=53f99160&scoped=true&lang=scss"
import "../style/global.scss?vue&type=style&index=1&lang=scss"

import exportComponent from "/Volumes/wangxiaochuan/personal/work/目睹复刻-博鳌/live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f99160"]])

export default __exports__